import * as React from 'react';
import { LocationDescriptorObject } from 'history';
import { useLocation } from 'react-router-dom';

export enum Route {
  ROOT = '/',
  HOME = 'home',
  SEARCHINVENTORY = 'search inventory',
  RESULTS = 'results',
  DETAILS = 'details',
  FAVOURTIES = 'favourites'
}

const getRouteFromUrl = (location: LocationDescriptorObject): Route => {
  const pathArr = location?.pathname?.split("/");
  const hasValidRoute = (item: string) => item === 'models' || item === 'results' || item === 'details' || item === 'favourites';
  const index = pathArr?.findIndex(hasValidRoute);
  const pathname = pathArr?.[index as number];

  switch (pathname) {
    case 'models':
      return Route.SEARCHINVENTORY;
    case 'results':
      return Route.RESULTS;
    case 'details':
      return Route.DETAILS;
    case 'favourites':
        return Route.FAVOURTIES;
    default:
      return Route.HOME;
  }
}

export const useRoute = (): Route  => {
  const location = useLocation();
  const [route, setRoute] = React.useState(getRouteFromUrl(location));

  React.useEffect(() => setRoute(getRouteFromUrl(location)), [location]);

  return route;
}
